module.exports = __webpack_public_path__ + "static/media/btn-light-off.4b94ee74.svg";